const CONSENT = [
  ["Confidentiality", "What is shared in session stays in session. Exceptions are limited to situations involving risk of serious harm, or where the law requires disclosure."],
  ["Cancellation Policy", "Please give at least 24 hours' notice to reschedule. Sessions cancelled with less notice may be charged in full."],
  ["Session Structure", "Sessions typically last 50–60 minutes. We'll begin with a check-in, work with what's most alive, and close with grounding."],
];

export function Consent() {
  return (
    <section className="wrap-s section">
      <h1 className="center">Consent & Boundaries</h1>
      <p className="center soft">A shared understanding of how we'll work together.</p>
      <div className="accordion">
        {CONSENT.map(([title, body]) => (
          <details key={title}><summary>{title}</summary><p>{body}</p></details>
        ))}
        <details>
          <summary>Professional Boundaries</summary>
          <p>To maintain the integrity and effectiveness of our counselling relationship, I maintain these professional boundaries:</p>
          <ul>
            <li><strong>No dual relationships:</strong> I don't engage in personal relationships with current or former clients, nor do I accept business opportunities or social connections outside of counselling.</li>
            <li><strong>No gift exchanges:</strong> Gifts of significant value are not accepted, as they can complicate the counselling relationship.</li>
            <li><strong>Communication boundaries:</strong> Our relationship is limited to scheduled sessions. Communication outside sessions (email, WhatsApp, phone) is for appointments only, not counselling matters.</li>
            <li><strong>No social media contact:</strong> I do not connect with clients via personal social media accounts to maintain professional confidentiality.</li>
            <li><strong>Response time:</strong> I aim to respond to messages within 24 hours. For urgent matters between sessions, please contact emergency services.</li>
          </ul>
        </details>
        <details>
          <summary>Limitations of Counselling</summary>
          <p>While counselling is a powerful tool for personal growth and change, it's important to understand its limitations:</p>
          <ul>
            <li><strong>Not medical treatment:</strong> Counselling is not a substitute for medical care, psychiatric treatment, or emergency services. If you need medical help, please see a healthcare provider.</li>
            <li><strong>No guarantees:</strong> I cannot guarantee specific outcomes. Your progress depends on your engagement, commitment, and readiness to change.</li>
            <li><strong>Crisis situations:</strong> If you are in acute crisis or at imminent risk, counselling alone is not appropriate. You will be referred to emergency services.</li>
            <li><strong>Managed expectations:</strong> Healing is a process. Change takes time, and some sessions may feel more productive than others.</li>
          </ul>
        </details>
        <details>
          <summary>My Qualifications & Scope</summary>
          <p>I am an ASCHP-registered Specialist Wellness Counsellor (Registration No. SWC24/7080). My qualifications include a BA Honours in Counselling Psychology and professional training through Humanitas Training & Counselling. I provide counselling support for personal, relational, and life challenges within my scope of practice.</p>
          <p>If your concerns fall outside my scope or require specialized treatment, I will refer you to appropriate professionals.</p>
        </details>
        <details>
          <summary>Session Conduct</summary>
          <p>To create the best counselling environment, I ask that you:</p>
          <ul>
            <li>Arrive on time and fully present for your session</li>
            <li>Avoid being under the influence of substances during sessions</li>
            <li>Treat this space with respect and care</li>
            <li>Be honest and authentic about your experiences</li>
            <li>Respect that this is a professional relationship with clear boundaries</li>
          </ul>
        </details>
        <details>
          <summary>Right to Terminate</summary>
          <p>You have the right to end counselling at any time. If I feel that our work together is not beneficial or that another professional might better serve you, I will discuss this with you directly and support you in finding appropriate alternative resources.</p>
        </details>
      </div>
    </section>
  );
}
